import * as $GoodsCategoryApi from '@/api/category';

export class GoodsCategoryProxy {
  children: GoodsCategoryProxy[] = [];
  props: any;

  static map: any = {};

  constructor(
    public self_goods = '',
    public id = 0,
    public label = '',
    public value = '',
    public level = 0,
    public leaf = level === 3,
  ) {
    if (this.id === 0) {
      this.load();
      this.props = {
        lazy: true,
        emitPath: false,
        checkStrictly: true,
        expandTrigger: 'hover',
        lazyLoad: (node, resolve) => {
          if (!node.data) return resolve();
          node.data.load().then(resolve);
        },
      };
    }
    if (this.leaf) this.children = null!;
  }

  load() {
    if (this.leaf || this.children.length) return Promise.resolve(this.children);

    return $GoodsCategoryApi.getCategoryChildren(this.id).then(resp => {
      const dataList = resp.filter(item => {
        if (this.self_goods === '9') {
          return item.name === '蛋糕'
        } else {
          return item;
        }
      })
      this.children = dataList.map(item => {
        const proxy = new GoodsCategoryProxy(
          this.self_goods,
          item.category_id,
          item.name,
          item.category_path,
          this.level + 1,
        );
        GoodsCategoryProxy.map[item.category_path] = proxy;
        return proxy;
      }).sort((a, b) => a.id - b.id);
      return this.children;
    });
  }

  change(path) {
    GoodsCategoryProxy.map[path].load();
  }
}

export const $goodsCategory = {
  create: (self_goods = '') => new GoodsCategoryProxy(self_goods),
};
